"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMutex = void 0;
/**
 * Creates a callback function that can be used to emulate a mutex,
 * very useful for ensuring text operations are applied in order
 * */
const createMutex = () => {
    let token = true;
    return (f, g) => {
        if (token) {
            token = false;
            try {
                f();
            }
            finally {
                token = true;
            }
        }
        else if (g !== undefined) {
            g();
        }
    };
};
exports.createMutex = createMutex;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXV0ZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbXV0ZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBS0E7OztLQUdLO0FBQ0UsTUFBTSxXQUFXLEdBQUcsR0FBWSxFQUFFO0lBQ3ZDLElBQUksS0FBSyxHQUFHLElBQUksQ0FBQztJQUNqQixPQUFPLENBQUMsQ0FBQyxFQUFFLENBQUMsRUFBRSxFQUFFO1FBQ2QsSUFBSSxLQUFLLEVBQUUsQ0FBQztZQUNWLEtBQUssR0FBRyxLQUFLLENBQUM7WUFDZCxJQUFJLENBQUM7Z0JBQ0gsQ0FBQyxFQUFFLENBQUM7WUFDTixDQUFDO29CQUFTLENBQUM7Z0JBQ1QsS0FBSyxHQUFHLElBQUksQ0FBQztZQUNmLENBQUM7UUFDSCxDQUFDO2FBQU0sSUFBSSxDQUFDLEtBQUssU0FBUyxFQUFFLENBQUM7WUFDM0IsQ0FBQyxFQUFFLENBQUM7UUFDTixDQUFDO0lBQ0gsQ0FBQyxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBZFcsUUFBQSxXQUFXLGVBY3RCIn0=